import { render } from "./RiskRegistry.vue?vue&type=template&id=0b161270&scoped=true"
import script from "./RiskRegistry.js?vue&type=script&lang=js"
export * from "./RiskRegistry.js?vue&type=script&lang=js"

import "./RiskRegistry.vue?vue&type=style&index=0&id=0b161270&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b161270"]])

export default __exports__